import { type SxProps, type Theme } from '@mui/material'

export const CARD_WIDTH = '240px'

export const styles = {
  intro: {
    mb: '20px'
  } satisfies SxProps<Theme>,
  districtsHint: {
    mb: '16px'
  } satisfies SxProps<Theme>,
  cardRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'stretch'
  } satisfies SxProps<Theme>,
  card: (headerColor: string) => ({
    border: `1px solid ${headerColor}`,
    borderRadius: '8px',
    overflow: 'hidden',
    width: CARD_WIDTH,
    display: 'flex',
    flexDirection: 'column'
  } satisfies SxProps<Theme>),
  cardHeader: (headerColor: string) => ({
    backgroundColor: headerColor,
    color: 'var(--white)',
    px: '14px',
    py: '10px'
  } satisfies SxProps<Theme>),
  cardBody: (bodyColor: string) => ({
    backgroundColor: bodyColor,
    p: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flexGrow: 1
  } satisfies SxProps<Theme>),
  buildingLink: (notStarted: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    color: notStarted ? 'var(--purple-500)' : 'var(--blue-500)',
    fontWeight: 600,
    textAlign: 'left'
  } satisfies SxProps<Theme>),
  actionsCard: {
    width: CARD_WIDTH,
    backgroundColor: 'var(--purple-50)',
    borderRadius: '8px',
    p: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '28px'
  } satisfies SxProps<Theme>,
  actionsBlock: {
    textAlign: 'center'
  } satisfies SxProps<Theme>,
  actionsTitle: {
    fontWeight: 700,
    mb: '12px'
  } satisfies SxProps<Theme>
}
